<template>
  <div>
    <CRow class="pt-5">
      <CCol sm="3" v-if="countPages > 1">
        <CPagination :pages="countPages" class="dataTable__pagination" :doubleArrows="false" :active-page.sync="activePage" ref="pagination">
          <template slot="previous-button">
            <span class="pagination__button p-2">
              <i class="icon fas fa-angle-left font-weight-light fa-2x text-gray-500"></i>
            </span>
          </template>

          <template slot="next-button">
            <span class="pagination__button p-2">
              <i class="icon fas fa-angle-right font-weight-light fa-2x text-gray-500"></i>
            </span>
          </template>
        </CPagination>

        <div class="page-item d-flex justify-content-center paginationDetail text-gray-600" v-if="countPages > 1">
          <span class="page-active pr-1">{{ activePage }}</span> / {{ countPages }}
        </div>
      </CCol>
      <CCol class="text-right">
        <!-- <button class="btn btn-white px-4 py-3 font-weight-bold text-gray-600" tag="button">
          EXPORT
          <CIcon
            name="arrowExport"
            size="custom-size"
            :height="18"
            class="ml-2"
            viewBox="0 0 32 32"
          />
        </button> -->
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CRow>
          <CCol>
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.sms.text.dateSent') }}
            </div>
            <div class="text-gray-600">
              {{ activeScheduling ? formatDateTimeFull(activeScheduling.schedulingDatetime, null, null, false) : '' }} ({{
                activeScheduling.timezone
              }})
            </div>
          </CCol>
        </CRow>
        <CRow class="mt-3">
          <CCol>
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.sms.text.sender') }}
            </div>
            <div class="text-gray-600">
              {{ activeScheduling.senderName }}
            </div>
          </CCol>
        </CRow>

        <CRow v-if="activeScheduling && activeScheduling.segments.length > 0" class="mt-4">
          <CCol>
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.sms.text.segments') }}
            </div>
            <CRow>
              <CCol sm="7">
                <div v-for="(segment, index) in activeScheduling.segments" :key="index">
                  <CBadge v-if="segment.segmentName" class="font-weight-semi-bold px-3 py-2 font-base mx-1 my-1" color="primary">
                    {{ segment.segmentName }}
                  </CBadge>
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol sm="7">
            <div class="text-gray-700 font-weight-bold mb-1">
              {{ $t('campaign.campaignResult.dashboard.sms.text.performance') }}
            </div>
            <CRow>
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.sms.text.delivered') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('sms', activeScheduling.schedulingId, 'delivered')">
                  {{ activeScheduling ? activeScheduling.performance.deliveredCount : '' }}
                </a>
                <span class="min-w">{{ deliveredPercent }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />

            <CRow>
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.sms.text.notDelivered') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('sms', activeScheduling.schedulingId, 'notdelivered')">
                  {{ activeScheduling ? activeScheduling.performance.notDeliveredCount : '' }}
                </a>
                <span class="min-w">{{ notDeliveredPercent }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />

            <CRow>
              <CCol class="text-gray-600">
                <span class="performance-desc">{{ $t('campaign.campaignResult.dashboard.sms.text.pending') }}</span>
              </CCol>
              <CCol class="text-right">
                <a class="performance-link text-gray-600 mr-2 min-w" @click="redirctToResume('sms', activeScheduling.schedulingId, 'pending')">
                  {{ activeScheduling ? activeScheduling.performance.pendingCount : '' }}
                </a>
                <span class="min-w">{{ pendingPercent }}%</span>
              </CCol>
            </CRow>
            <hr class="mt-1" />
          </CCol>
        </CRow>

        <CRow class="mt-4" v-if="activeScheduling.performance.topLocations.sent.length > 0">
          <CCol sm="7">
            <div class="text-gray-700 font-weight-bold">
              {{ $t('campaign.campaignResult.dashboard.sms.text.topLocationsBySent') }}
            </div>
            <div class="scroll-area-message mt-3 pr-none">
              <div v-for="(country, index) in activeScheduling.performance.topLocations.sent" :key="index">
                <CRow>
                  <CCol sm="2" style="padding-right: 0px; padding-lef: 1px" class="text-left">
                    <img :src="getFlag(country.countryId)" width="30" />
                  </CCol>
                  <CCol sm="5" class="text-gray-600">
                    {{ country.countryCode }}
                  </CCol>
                  <CCol class="text-gray-600 text-right">
                    <span class="mr-2 min-w">{{ country.count }}</span
                    ><span class="text-gray-base min-w">{{ topLocationPercent(activeScheduling, country.count) }}%</span>
                  </CCol>
                </CRow>
                <hr class="mt-1" />
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>

      <!-- Área mensagem -->
      <CCol class="text-left">
        <SmartphoneModel
          :hours="activeScheduling ? formatDateTimeFull(new Date(activeScheduling.schedulingDatetime).toISOString()).split(' ')[3] : ''"
          :senderName="activeScheduling.senderName"
          :messages="[activeScheduling.content]"
        />
        <!-- <SmartphoneModel :messages="messages"/> -->
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { dateFormatStringFull } from '@/utils/dateUtil.js'
import countries from '../../../../countriesList'
import SmartphoneModel from '@/components/SmartphoneModel.vue'

export default {
  props: {
    campaignResult: Object,
  },
  components: {
    SmartphoneModel,
  },
  computed: {
    countPages: function () {
      if (this.campaignResult.channels) {
        return this.campaignResult.channels.sms.schedulings.length
      }
      return 0
    },
    activeScheduling: function () {
      if (this.campaignResult.channels) {
        return this.campaignResult.channels.sms.schedulings[this.activePage - 1]
      }
      return null
    },
  },
  data() {
    return {
      activePage: 1,
      deliveredPercent: 0,
      notDeliveredPercent: 0,
      pendingPercent: 0,
    }
  },
  watch: {
    activeScheduling: function (newSchedule) {
      if (newSchedule) {
        this.calculatingPercent()
      }
    },
  },
  methods: {
    formatDateTimeFull(date, timezone, format, changeZone = true) {
      return dateFormatStringFull(date, timezone, format, changeZone)
    },
    getFlag(key) {
      return countries.find((elm) => elm.code?.toUpperCase() === key?.toUpperCase())?.flag
    },
    redirctToResume(scheduleType, scheduleId, type) {
      this.$router.push({
        name: 'campaignResume',
        params: {
          campaignId: this.$route.params.campaignId,
          scheduleType: scheduleType,
          scheduleId: scheduleId,
          type: type,
        },
      })
    },
    calculatingPercent() {
      if (this.activeScheduling && this.activeScheduling.performance && this.activeScheduling.totalRecipientsCount > 0) {
        this.deliveredPercent = Math.round((this.activeScheduling.performance.deliveredCount * 100) / this.activeScheduling.totalRecipientsCount)

        this.notDeliveredPercent = Math.round(
          (this.activeScheduling.performance.notDeliveredCount * 100) / this.activeScheduling.totalRecipientsCount,
        )

        this.pendingPercent = Math.round((this.activeScheduling.performance.pendingCount * 100) / this.activeScheduling.totalRecipientsCount)
      }
    },

    topLocationPercent(item, value) {
      let result = 0
      if (item && item.performance && item.performance.deliveredCount > 0) {
        result = Math.round((value * 100) / item.performance.deliveredCount)
      }
      // if (item && item.performance && item.totalRecipientsCount > 0) {
      //   result = Math.round((value * 100) / item.totalRecipientsCount)
      // }
      return result > 100 ? 100 : result
    },
  },
  mounted() {
    this.calculatingPercent()
  },
}
</script>

<style lang="scss">
.performance-link {
  cursor: pointer;
  text-decoration: underline !important;
}

.performance-desc {
  font-size: $font-size-xs !important;
  font-weight: $font-weight-semi-bold;
}

.scroll-area-message {
  overflow-y: auto;
  overflow-x: hidden;
  height: 250px;
}

.min-w {
  min-width: 45px;
  display: inline-block;
  text-align: center;
}
</style>
